import React, { useState, useContext, useEffect, useRef } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import Ic from "../common/Ic";
import PushToggle from "../common/PushToggle";
import { LANGUAGES } from "../../i18n";
import { rad, sp } from "../../constants/styles";

export default function TopBar() {
  const { t, h, lang, setLang, dk, setDk, role, notifs = [], setNotifs, currUserId, go, setOpenChat, setSelMaintId, doLogout, flash, pays, tens, plan, orgName } = useContext(Ctx);
  const [showNotifs, setShowNotifs] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const notifRef = useRef(null);
  const notifBtnRef = useRef(null);
  const settsRef = useRef(null);
  const settsBtnRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showNotifs && notifRef.current && !notifRef.current.contains(event.target) && !notifBtnRef.current.contains(event.target)) {
        setShowNotifs(false);
      }
      if (showSettings && settsRef.current && !settsRef.current.contains(event.target) && !settsBtnRef.current.contains(event.target)) {
        setShowSettings(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifs, showSettings]);

  const ct = currUserId;
  // Filter notifications strictly by role and user ID — no cross-user leaking
  const myNotifs = (() => {
    const all = notifs || [];
    if (role === "landlord") return all.filter(n => n.forRole === "landlord");
    if (role === "tenant")   return all.filter(n => n.forRole === "tenant" && n.forTid === ct);
    if (role === "service")  return all.filter(n => n.forRole === "service" && n.forTid === ct);
    if (role === "admin")    return all.filter(n => n.forRole === "admin");
    return [];
  })();
  const unread = myNotifs.filter(n => !n.read).length;
  const markAllRead = () => {
    setNotifs(prev => (prev || []).map(n => {
      let isMine = false;
      if (role === "landlord") isMine = n.forRole === "landlord";
      else if (role === "tenant") isMine = n.forRole === "tenant" && n.forTid === ct;
      else if (role === "service") isMine = n.forRole === "service" && n.forTid === ct;
      else if (role === "admin") isMine = n.forRole === "admin";
      return isMine ? { ...n, read: true } : n;
    }));
    api.markRead(role, ct);
  };

  // FIX #16: CSV export with proper comma/quote escaping
  const exportToCsv = () => {
    const filtered = role === "tenant" ? (pays || []).filter(p => p.tid === ct) : (pays || []);
    if (filtered.length === 0) { flash(t.noDataExport); return; }
    const escapeCsv = (val) => {
      const str = String(val);
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    };
    const headers = ["ID", "Tenant", "Amount", "Month", "Status", "Date", "Method"];
    const rows = filtered.map(p => {
      const te = tens.find(t => t.id === p.tid)?.name || "Unknown";
      return [p.id, te, p.amt + (p.com || 0), p.mo, p.st, p.dt || "-", p.mth || "-"].map(escapeCsv).join(",");
    });
    const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "payments_export.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    flash(t.csvExported);
    setShowSettings(false);
  };

  return <div style={{ background: `${h.bg}e8`, backdropFilter: "saturate(180%) blur(24px)", WebkitBackdropFilter: "saturate(180%) blur(24px)", borderBottom: `1px solid ${h.bd}`, padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 999 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ width: 34, height: 34, borderRadius: rad.sm + 2, background: `${h.ac}12`, display: "flex", alignItems: "center", justifyContent: "center" }}><Ic n="bldg" s={17} c={h.ac} /></div>
      <div>
        <div style={{ color: h.tx, fontWeight: 700, fontSize: 14, letterSpacing: "-0.2px" }}>{orgName || t.app}</div>
        <div style={{ color: h.ts || h.sc, fontSize: 11, fontWeight: 500 }}>{role === "landlord" ? t.landlord : role === "admin" ? (t.superAdmin || "Super Admin") : role === "service" ? (t.servicePerson || "Service") : t.tenant}</div>
      </div>
    </div>
    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
      <div style={{ position: "relative" }}>
        <button ref={notifBtnRef} onClick={() => { setShowNotifs(!showNotifs); if (!showNotifs) markAllRead(); }} style={{ background: h.ib, border: `1px solid ${h.bd}`, padding: "7px 8px", borderRadius: rad.sm, cursor: "pointer", display: "flex", position: "relative" }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={h.ts || h.sc} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 01-3.46 0" /></svg>
          {unread > 0 && <div style={{ position: "absolute", top: -3, right: -3, background: h.rd, color: "#fff", fontSize: 9, fontWeight: 700, width: 16, height: 16, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 2px 6px ${h.rd}40` }}>{unread}</div>}
        </button>
        {showNotifs && <div ref={notifRef} className="animate-scaleIn" style={{ position: "absolute", top: 44, right: 0, width: 300, maxHeight: 380, overflowY: "auto", background: h.cd, borderRadius: rad.lg, boxShadow: h.s3 || "0 8px 30px rgba(0,0,0,.25)", zIndex: 100, padding: sp.sm, border: `1px solid ${h.bd}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px 6px" }}><span style={{ color: h.tx, fontWeight: 700, fontSize: 14 }}>{t.notif}</span>
            <button onClick={() => setShowNotifs(false)} style={{ background: h.ib, border: "none", color: h.ts || h.sc, cursor: "pointer", fontSize: 14, width: 28, height: 28, borderRadius: rad.sm, display: "flex", alignItems: "center", justifyContent: "center" }}>{"\u2715"}</button></div>
          {myNotifs.length === 0 && <div style={{ color: h.tt || h.sc, fontSize: 13, textAlign: "center", padding: 28 }}>{t.noNotif}</div>}
          {myNotifs.slice(0, 15).map(n => {
            // Deep-link: determine target page based on notification type + role
            const getTarget = () => {
              const ty = n.type || "";
              if (ty.startsWith("chat")) {
                if (role === "tenant") return "tenChat";
                const pid = ty.split(":")[1];
                if (pid) setOpenChat(pid);
                return "chatList";
              }
              // "job:<maintId>" — used for landlord→service assignment notifications.
              // Routes the SP to their My Jobs list (where the Accept button lives);
              // selMaintId is set so the list can highlight/scroll to that specific job.
              if (ty.startsWith("job:")) {
                const jobId = ty.slice(4);
                if (role === "service") {
                  if (jobId && setSelMaintId) setSelMaintId(jobId);
                  return "spJobs";
                }
                return "maint";
              }
              if (ty === "payment" || ty === "rent") return role === "tenant" ? "pay" : "pay";
              if (ty === "maintenance" || ty === "maint") return role === "tenant" ? "maint" : "maint";
              if (ty === "lease" || ty === "agreement") return role === "tenant" ? "tenLease" : "agreement";
              if (ty === "tenant_request" || ty === "approval") return role === "tenant" ? "dash" : "tens";
              if (ty === "service" || ty === "job") return role === "service" ? "dash" : "maint";
              if (ty === "alert") return "dash";
              // Default: go to dashboard
              return "dash";
            };
            return <div key={n.id} onClick={() => {
              const target = getTarget();
              go(target);
              setShowNotifs(false);
            }} style={{ padding: "10px 10px", borderRadius: rad.sm, marginBottom: 2, background: n.read ? "transparent" : `${h.ac}06`, cursor: "pointer", transition: "background 0.15s" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <div style={{ width: 8, height: 8, borderRadius: 4, background: (n.type || "").startsWith("chat") ? h.ac : n.type === "payment" || n.type === "rent" ? h.gn : n.type === "lease" || n.type === "agreement" ? h.ac : n.type === "maintenance" || n.type === "maint" ? "#f59e0b" : h.wn, marginTop: 5, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ color: h.tx, fontSize: 13, lineHeight: 1.4 }}>{n.msg}</div>
                  <div style={{ color: h.tt || h.sc, fontSize: 11, marginTop: 3 }}>{n.time}</div>
                </div>
                <span style={{ color: h.ac, fontSize: 11, marginTop: 4, flexShrink: 0 }}>{"\u203A"}</span>
              </div>
            </div>;
          })}
        </div>}
      </div>
      <div style={{ position: "relative" }}>
        <button ref={settsBtnRef} onClick={() => setShowSettings(!showSettings)} style={{ background: h.ib, border: `1px solid ${h.bd}`, padding: "7px 8px", borderRadius: rad.sm, cursor: "pointer", display: "flex" }}><Ic n="gear" s={15} c={h.ts || h.sc} /></button>
        {showSettings && <div ref={settsRef} className="animate-scaleIn" style={{ position: "absolute", top: 44, right: 0, width: 260, background: h.cd, borderRadius: rad.lg, boxShadow: h.s3 || "0 8px 30px rgba(0,0,0,.25)", zIndex: 100, padding: sp.sm, border: `1px solid ${h.bd}` }}>
          <div style={{ padding: "8px 12px", marginBottom: 4, fontWeight: 700, color: h.tx, fontSize: 14 }}>{t.settings}</div>
          {/* Current Plan Card — always clickable → Settings for plan management */}
          {role === "landlord" && plan && (() => {
            const isMaxPlan = plan.type === "pro";
            const isPaid = plan.type !== "free";
            const isExpired = plan.planStatus === "expired";
            const isExpiring = isPaid && plan.daysRemaining != null && plan.daysRemaining <= 7 && plan.daysRemaining > 0;
            const borderColor = isExpired ? h.rd + "40" : isExpiring ? h.wn + "40" : isPaid ? h.gn + "30" : h.bd;
            const bgColor = isExpired ? `${h.rd}06` : isExpiring ? `${h.wn}06` : isPaid ? `${h.gn}08` : `${h.ac}08`;
            return <div onClick={() => { go("settings"); setShowSettings(false); }} style={{ margin: "4px 8px 10px", padding: "10px 12px", borderRadius: rad.md || 10, background: bgColor, border: `1px solid ${borderColor}`, cursor: "pointer", transition: "all 0.15s ease" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: h.tt || h.sc, fontSize: 9, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.currentPlan || "Current Plan"}</div>
                  <div style={{ color: h.tx, fontWeight: 700, fontSize: 14, marginTop: 2 }}>{plan.name || (plan.type === "free" ? "Free" : plan.type?.charAt(0).toUpperCase() + plan.type?.slice(1))}</div>
                </div>
                {isExpired
                  ? <span style={{ background: `${h.rd}15`, color: h.rd, padding: "3px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700 }}>Expired</span>
                  : isPaid
                    ? <span style={{ background: `${h.gn}15`, color: h.gn, padding: "3px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700 }}>{"\u2713 Active"}</span>
                    : <span style={{ background: h.pp || h.ac, color: "#fff", borderRadius: 8, padding: "4px 12px", fontSize: 11, fontWeight: 700 }}>{t.planUpgrade || "Upgrade"}</span>
                }
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <div style={{ color: h.sc, fontSize: 10 }}>{"\uD83C\uDFE0"} {plan.currentCount || 0}/{plan.maxProperties === 999999 ? "\u221E" : (plan.maxProperties || 2)}</div>
                  {isPaid && plan.daysRemaining != null && <div style={{ color: isExpired ? h.rd : isExpiring ? h.wn : h.sc, fontSize: 10, fontWeight: isExpiring || isExpired ? 700 : 400 }}>{"\u23F3"} {plan.daysRemaining > 0 ? `${plan.daysRemaining}d left` : "Expired"}</div>}
                  {!isPaid && plan.features && <div style={{ color: h.sc, fontSize: 10 }}>{"\u2728"} {plan.features.length} features</div>}
                </div>
                <div style={{ color: isExpired ? h.rd : h.ac, fontSize: 10, fontWeight: 600 }}>{isExpired ? (t.renewPlan || "Renew") : !isMaxPlan ? (isPaid ? (t.changePlan || "Change Plan") : (t.planUpgrade || "Upgrade")) : (t.managePlan || "Manage")} {"\u203A"}</div>
              </div>
            </div>;
          })()}
          <div style={{ padding: "6px 12px 4px" }}><span style={{ color: h.tt || h.sc, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.lang}</span></div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, padding: "4px 12px 10px" }}>
            {LANGUAGES.map(l => <button key={l.code} onClick={() => { setLang(l.code); }} style={{ padding: "5px 12px", borderRadius: rad.pill, border: lang === l.code ? `1.5px solid ${h.ac}` : `1px solid ${h.bd}`, background: lang === l.code ? `${h.ac}12` : "transparent", color: lang === l.code ? h.ac : h.ts || h.sc, cursor: "pointer", fontSize: 11, fontWeight: lang === l.code ? 700 : 400 }}>{l.native}</button>)}
          </div>
          {/* Web Push toggle — single source of truth, visible to every role
              from one place (no Settings/Profile/Dashboard duplication).
              Renders as a compact menu row matching the rows below. */}
          <PushToggle />
          {[
            (role === "tenant" || role === "service") ? [t.profile || "Profile", "\u2192", () => { go("profile"); setShowSettings(false); }] : null,
            role === "landlord" ? [t.settings || "Settings", "\u2192", () => { go("settings"); setShowSettings(false); }] : null,
            role === "landlord" ? [t.reports || "Reports", "\u2192", () => { go("reports"); setShowSettings(false); }] : null,
            role === "landlord" ? ["\u26A1 AI Assistant", "\u2192", () => { go("aiAssistant"); setShowSettings(false); }] : null,
            [t.dark, dk ? t.onTxt : t.offTxt, () => setDk(!dk)],
            role === "tenant" ? [t.viewAgr, "\u2192", () => { go("tenAgr"); setShowSettings(false); }] : null,
            // State-aware Rent Act FAQ. Shown to every role (landlord +
            // tenant + service) since rent law affects all of them, but
            // with role-aware framing — "Know Your Rights" for tenants,
            // "Rent Act Guide" for landlords (RentActFAQ.js handles this).
            (role === "tenant" || role === "service")
                ? [t.knowYourRights || "Know Your Rights", "\u2192", () => { go("faq"); setShowSettings(false); }]
                : role === "landlord"
                ? [t.rentActGuide || "Rent Act Guide", "\u2192", () => { go("faq"); setShowSettings(false); }]
                : null,
            // Always-visible Terms + Privacy links — every user has the
            // right to re-read what they accepted at signup. Privacy
            // also satisfies DPDP Act Section 5 transparency duty.
            [t.termsAndConditions || "Terms & Conditions", "\u2192", () => { go("terms"); setShowSettings(false); }],
            [t.privacyPolicy || "Privacy Policy", "\u2192", () => { go("privacy"); setShowSettings(false); }],
            (plan.features || []).includes("csv_export") ? [t.exportCsv, "\u2B07", exportToCsv] : null,
            [t.logout, "\u2192", () => { doLogout(); setShowSettings(false); }]
          ].filter(Boolean).map(([l, v, a], i) => <div key={i} onClick={a} style={{ padding: "10px 12px", borderRadius: rad.sm, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, color: h.tx, transition: "background 0.15s" }}>
            <span style={{ fontWeight: 500 }}>{l}</span><span style={{ fontWeight: 600, color: l === t.logout ? h.rd : h.ac, fontSize: 12 }}>{v}</span></div>)}
        </div>}
      </div>
    </div>
  </div>;
}
